export default __webpack_public_path__ + "static/media/banregio-logo-small.3c9dfe9d.png";